// extracted by mini-css-extract-plugin
export default {"form":"Checkout_form__dAEwd","control":"Checkout_control__tDxwh","actions":"Checkout_actions__AjxCP","submit":"Checkout_submit__fE41c","invalid":"Checkout_invalid__LaYKj"};